import axios from "axios";
import Cookie from "js-cookie";

export function sendRequest(functionName, formData = new FormData()) {
  formData.append("user_token", Cookie.get("token"));

  // to do: add user token from cookie

  return axios.post(`http://mvc.dade24.ir/api/${functionName}`, formData);
}
